import {Component, OnInit, TemplateRef} from '@angular/core';
import {ApiService} from '../../core/http/api.service';
import {ToastrService} from 'ngx-toastr';
import {base64ToFile, ImageCroppedEvent} from 'ngx-image-cropper';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {UtilsService} from '../../core/services/utils/utils.service';
import {Entity} from '../../core/models/entities/entity';
import {DashboardService} from '../dashboard.service';
import {User} from '../../core/models/user';

export interface Survey {
  questions: Question[];
  createdAt: number;
  updatedAt: number;
  id: string;
  title: string;
  startDate: number;
  endDate: number;
  status: 'pending' | 'published' | 'paused' | 'closed' | 'announced';
  resultAnnounced: boolean;
}

export interface Question {
  createdAt: number;
  updatedAt: number;
  id: string;
  question: string;
  result_suffix: string;
  options: Option[];
  survey: string;
}

export interface Option {
  option: string;
  image: string;
}

@Component({
    selector: 'app-banners',
    templateUrl: './surveys.component.html',
    styleUrls: ['./surveys.component.css'],
    standalone: false
})
export class SurveysComponent implements OnInit {

  loading = true;
  loaders = Array(10).fill(0);

  option = '';

  // Surveys
  polls: Survey[] = [];
  pollsCount = 0;
  page = 1;
  survey = {
    questions: [{
      question: '',
      options: []
    }],
  };

  constructor(private api: ApiService,
              private toastr: ToastrService,
              private modalService: BsModalService,
              private utils: UtilsService,
              private dashApi: DashboardService) {
  }

  ngOnInit(): void {
    this.getSurveys();
  }

  getSurveys(newPage: number = 1): void {
    this.api.getPolls({page: newPage}).subscribe(res => {
      const response = res?.response || {};
      this.polls = response.surveys || [];
      this.pollsCount = response.total_count || 0;
      this.loading = false;
    }, err => {
      this.utils.resErr(err);
      this.loading = false;
    });
  }

  surveyAction(idx, status: any): void {
    const surveyId = this.polls[idx].id;
    if (confirm('Are your sure, you want to update this Survey?')) {
      if (status === 'announce') {
        this.api.announcePollResult({surveyId}).subscribe(res => {
          console.log('Announce result response', res.response);
          this.getSurveys();
        });
      } else {
        this.api.updatePollStatus({status, surveyId}).subscribe(res => {
          console.log('Update poll response', res.response);
          this.getSurveys();
        }, err => this.utils.resErr(err));
      }
    }
  }

  pageChange(event): void {
    this.page = event;
    this.loading = true;
    this.getSurveys(event);
    window.scrollTo(0, 0);
  }
}
